// extracted by mini-css-extract-plugin
export default {"appInfo":"application_appInfo__QzcvV"};